module.exports = __webpack_public_path__ + "static/media/mace.3df39071.svg";